import './index.css'
import Button from '../button';
import { deleteAccount } from '../../functions/deleteAccount';

function DeleteAccount({display,functionForButton}){
    let displayOfBlur = display ? 'block' : 'none';

    return <div id="blur-wrapper" style={{display:displayOfBlur}}>
    <div id="add-module" className='delete-account-module'>
    <div className="input-module-title-holder">
    <h2 className="big-text">Delete your account?</h2>
    <button className="close-btn" onClick={functionForButton} aria-label="Close">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
    </button>
    </div>
    <div className="small-text">Deleting your account is irreversible, and you will lose all data associated with your account.</div>
    <div className="button-holder">
    <Button text='Confirm' addedFunction={deleteAccount}></Button>
    </div>
    </div>
    </div>;
}

export default DeleteAccount